import { Popover, Checkbox, Upload, Spin, message, Tooltip } from "antd"
import { useCallback, useMemo, useState, useContext} from "react"
import styles from './index.module.scss'
import LazyLoad from '@view/compoents/LazyLoad';
import Utils from '@utils/utils'
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons';
import { RESOURCE_TYPE } from '@utils/CONST'
import Iconfont from '@utils/Iconfont';
import { AppContext } from '@utils/AppContext';
import UploadRequirements from "../UploadRequirements";

const SelectionItem = (props) => {
    const {
        className = '',
        hoverActionButtonClassName = '',
        hoverActionContent = '去改图',
        // 素材是否是视频
        isVideo,
        // 普通素材
        record,
        // 多选
        multiple,
        // 选中
        actived,
        // 选中态额外样式
        activeClassName = '',
        // 隐藏多选勾选框
        hideCheckbox = false,
        // 超出可选数量
        overflow,
        // 超出可选数量提示文案
        overflowTips,
        // 显示素材名
        showName,
        // 收藏资源是否禁用
        favorDisabled,
        // 工具组
        toolGroup,
        // 点击
        onClick,
        // 点击子项
        onMoreClick,
        onEditImageAction,
        resourceType,
        useNameAsTitle = false,
        materialScope = 'personal',
    } = props

    const { globalOrgInfo } = useContext(AppContext)
    const isPersonal = globalOrgInfo?.isPersonal;
    const canManage = record.canManage !== false;
    const isCreativeMaterialEntry = useMemo(() => {
        return !!record?.attr?.isCreativeMaterialEntry
    }, [record])
    const displayImageUrl = useMemo(() => {
        if (isCreativeMaterialEntry) return record?.imageUrlWithVersion || record?.imageUrl
        return Utils.getImgThumbnail(record?.imageUrlWithVersion)
    }, [isCreativeMaterialEntry, record])

    // 素材处理中
    const isProcess = useMemo(() => {
        return ["started", "pending", "processing"].includes(record?.attr?.status) ||
            ("maskStatus" in record.attr ? record.attr?.maskStatus == "processing" : false)
    }, [record])
    const isMaterialGenerating = useMemo(() => {
        return ["started", "pending", "processing"].includes(record?.attr?.status)
    }, [record])
    const isFailed = useMemo(() => {
        return record?.attr?.status == "failed" || record?.attr?.maskStatus == "failed"
    }, [record])
    // 素材处理完成
    const isSuccess = useMemo(() => {
        if ("status" in (record?.attr || {})) return record?.attr?.status == "succeeded"
        return true
    }, [record])
    // 素材是否有子项
    const hasChild = useMemo(() => {
        return record.subList.length > 0
    }, [record])
    // 素材是否可选：素材处理中/超出可选数量
    const selectable = useMemo(() => {
        if (!isSuccess) return false
        if (overflow) return false
        return true
    }, [isSuccess, overflow])
    // 素材是否收藏
    const isFavorite = useMemo(() => {
        return record.isFavorite
    }, [record.isFavorite])
    // 是否是vip资源
    const isPrivate = useMemo(() => {
        return record.attr.private == 1
    }, [record])
    // 素材是否可删除
    const removeable = useMemo(() => {
        return record.isCustom
    }, [record])
    // 收藏/取消收藏
    const handleFavor = e => {
        e?.stopPropagation?.()
        toolGroup?.onFavor?.()
    }
    // 删除
    const handleRemove = e => {
        e?.stopPropagation?.()
        toolGroup?.onRemove?.()
    }
    const handleMove = e => {
        e?.stopPropagation?.()
        toolGroup?.onMove?.()
    }
    const handleSort = e => {
        e?.stopPropagation?.()
        toolGroup?.onSort?.()
    }
    const handleFailedRemove = e => {
        e?.stopPropagation?.()
        if (canManage && removeable) {
            toolGroup?.onRemove?.()
        }
    }

    // 子项操作
    const [popoverOpen, setPopoverOpen] = useState(false)
    // 子项选中项
    const activedPopoverName = useMemo(() => {
        if (actived) return record.name
    }, [actived, record.name])
    // 子项点击
    const handlePopoverClick = (e, item) => {
        e?.stopPropagation?.()
        setPopoverOpen(false)
        onMoreClick(item, record)
    }
    const PopoverContent = (
        <div className={styles.PopoverContent}>
            {
                record.subList.map(item => (
                    <div
                        key={item.name}
                        className={`${styles.PopoverSelectionItem} ${item.name == activedPopoverName && styles.actived}`}
                        onClick={(e) => handlePopoverClick(e, item)}
                    >
                        <img src={Utils.getImgThumbnail(item.imageUrlWithVersion)} alt="" />
                    </div>
                ))
            }
        </div>
    )
    const handlePopoverTriggerClick = e => {
        e?.stopPropagation?.()
    }

    const handleOverflowClick = () => {
        message.warning(overflowTips)
    }

    const handleHoverActionClick = (e) => {
        e?.stopPropagation?.()
        if (onEditImageAction) {
            onEditImageAction(isCreativeMaterialEntry ? undefined : record)
            return
        }
        if (selectable) {
            onClick(record)
            return
        }
        if (overflow) handleOverflowClick()
    }

    const formartTitle = useMemo(() => {
        if (isProcess) return "生成中..."
        else {
            if (useNameAsTitle) return record?.name
            return record?.attr?.title
        }
    }, [record, isProcess, useNameAsTitle])

    const showHoverText = useMemo(() => {
        return (resourceType == RESOURCE_TYPE.GLASSES_TRYON || resourceType == RESOURCE_TYPE.SIM_TRYON) &&
            !isCreativeMaterialEntry &&
            !record?.attr?.refMask
    }, [resourceType, isCreativeMaterialEntry, record])
    const showResourceName = useMemo(() => {
        if (isCreativeMaterialEntry) return false
        return showName && !!formartTitle
    }, [isCreativeMaterialEntry, showName, formartTitle])


    const handleSelectionItemClick = useCallback(() => {
        if (isCreativeMaterialEntry) {
            if (onEditImageAction) {
                onEditImageAction?.()
                return
            }
            if (overflow) handleOverflowClick()
            return
        }

        if (selectable) {
            onClick?.(record)
            return
        }

        if (overflow) handleOverflowClick()
    }, [isCreativeMaterialEntry, onEditImageAction, selectable, onClick, record, overflow, handleOverflowClick])

    return (
        <div className={`${styles.SelectionItem} ${className} ${actived ? `${styles.actived} ${activeClassName}` : ''} ${isCreativeMaterialEntry ? styles.CreativeMaterialEntry : ''} ${isFailed ? styles.FailedItem : ''}`} onClick={handleSelectionItemClick}>
            {
                isFailed ? (
                    <div className={styles.SelectionItemFailed}>
                        {canManage && removeable && <Iconfont type="icon-Material-DeleteOutlined" onClick={handleFailedRemove} className={styles.FailedDeleteIcon} />}
                        <p>生成失败</p>
                        <p>虹豆已退回</p>
                    </div>
                ) : (
                    <>
                        <div className={`${styles.SelectionItemontent} ${overflow && !isCreativeMaterialEntry && styles.overflow}`}>
                            {
                                isVideo ?
                                    <LazyLoad.Video key={record?.imageUrlWithVersion} src={record?.imageUrlWithVersion} /> :
                                    <LazyLoad.Image key={record?.imageUrlWithVersion || record?.imageUrl} src={displayImageUrl} />
                            }
                            {isMaterialGenerating && (
                                <div className={styles.GeneratingMask}>
                                    <video
                                        className={styles.GeneratingVideo}
                                        src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/picProcessingBg.webm"
                                        autoPlay
                                        loop
                                        muted
                                        playsInline
                                    />
                                    <span className={styles.GeneratingText}>生成中...</span>
                                </div>
                            )}
                        </div>
                        {
                            showHoverText && <div className={styles.SelectionItemMask}>
                                {resourceType == RESOURCE_TYPE.SIM_TRYON ? '编辑重绘区域' : '标记佩戴区域'}
                            </div>
                        }
                        {!isProcess && !isCreativeMaterialEntry && !!onEditImageAction && (
                            <div
                                className={`${styles.HoverActionButton} ${hoverActionButtonClassName}`}
                                onClick={handleHoverActionClick}
                            >
                                {hoverActionContent}
                            </div>
                        )}
                        {
                            showResourceName &&
                            <div className={styles.ResourceName}>
                                <span>{formartTitle}</span>
                            </div>
                        } {
                            isPrivate &&
                            <i className={styles.PrivateIcon}></i>
                        } {
                            (multiple && actived && !hideCheckbox) &&
                            <Checkbox
                                className={styles.SelectionItemCheckbox}
                                checked={actived}
                            />
                        } {
                            isProcess ?
                                <div className={styles.SpinWrap}><Spin indicator={<LoadingOutlined style={{ fontSize: 40 }} spin />} /></div> :
                                !isCreativeMaterialEntry &&
                                <div className={styles.TriggerWrap}>
                                    {
                                        canManage && toolGroup?.onMove && !isPersonal && materialScope !== 'enterprise' &&
                                        <Tooltip title="分享到企业" mouseEnterDelay={0.5}>
                                            <div className={styles.TriggerItem} onClick={handleMove}><Iconfont type="icon-Material-MoveToEnterpriseOutlined" /></div>
                                        </Tooltip>
                                    } {
                                        canManage && toolGroup?.onSort &&
                                        <Tooltip title="移动" mouseEnterDelay={0.5}>
                                            <div className={styles.TriggerItem} onClick={handleSort}><Iconfont type="icon-Material-FolderMoveOutlined" /></div>
                                        </Tooltip>
                                    } {
                                        favorDisabled ? "" :
                                            isFavorite ?
                                                <Tooltip title="收藏" mouseEnterDelay={0.5}>
                                                    <div className={`${styles.TriggerItem} ${styles.favorited} ${styles.visible}`} onClick={handleFavor}><Iconfont type="icon-Material-FavoriteFilled" /></div>
                                                </Tooltip> :
                                                <Tooltip title="收藏" mouseEnterDelay={0.5}>
                                                    <div className={styles.TriggerItem} onClick={handleFavor}><Iconfont type="icon-Material-FavoriteOutlined" /></div>
                                                </Tooltip>
                                    } {
                                        hasChild &&
                                        <Popover
                                            placement="bottomLeft"
                                            open={popoverOpen}
                                            arrow={false}
                                            styles={{ body: { padding: 0 } }}
                                            trigger={"click"}
                                            content={PopoverContent}
                                            onOpenChange={value => setPopoverOpen(value)}
                                        >
                                            <div className={`${styles.TriggerItem} ${styles.visible}`} onClick={handlePopoverTriggerClick}><Iconfont type="icon-SwitcherOutlined" /></div>
                                        </Popover>
                                    } {
                                        canManage && removeable &&
                                        <Tooltip title="删除" mouseEnterDelay={0.5}>
                                            <div className={`${styles.TriggerItem} ${styles.deleteBtn}`} onClick={handleRemove}><Iconfont type="icon-Material-DeleteOutlined" /></div>
                                        </Tooltip>
                                    }
                                </div>
                        }
                    </>
                )
            }
        </div>
    )
}

const SelectionItemUploader = (props) => {
    const {
        resourceType = RESOURCE_TYPE.TRYON_MODEL,
        commoditySceneMode,
        onUpdate,
        onUpload,
        useModalTrigger = false,
        onTriggerClick,
    } = props
    // 上传中
    const [loading, setLoading] = useState(false)
    // 上传总数量
    const [totalNum, setTotalNum] = useState(0)
    // 上传成功数量
    const [succNum, setSuccNum] = useState(0)
    // 上传失败数量
    const [errorNum, setErrorNum] = useState(0)
    // 上传多个
    const uploadMultiple = useMemo(() => {
        if (resourceType == RESOURCE_TYPE.MODEL_SCENE) return true
        if (resourceType == RESOURCE_TYPE.COMMODITY_SCENE) return false
        else return true
    }, [resourceType])

    const maxCount = useMemo(() => {
        return 20
    }, [resourceType])
    // 上传文件类型
    const uploadAccept = useMemo(() => {
        if (resourceType == RESOURCE_TYPE.VIDEO_MODEL) {
            return "video/mp4"
        } else {
            return "image/jpeg,image/png,image/webp,image/avif"
        }
    }, [resourceType])
    // 显示图片要求 // 鞋子上脚和AI模特的场景没有要求
    const showUploadRequire = useMemo(() => {
        return resourceType == RESOURCE_TYPE.MODEL || resourceType == RESOURCE_TYPE.VIDEO_MODEL
    }, [resourceType])

    // 上传文件
    const uploadDebounce = useCallback(_.debounce(async (file, fileList) => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => uploadDebounce(file, fileList))
        if (!status) return
        if (maxCount && fileList.length > maxCount) {
            message.warning(`最多上传${maxCount}张图片，已自动忽略超出部分`)
            fileList = fileList.slice(0, maxCount)
        }
        setLoading(true)
        let totalNum = fileList.length
        setTotalNum(totalNum)
        let succNum = 0
        setSuccNum(succNum)
        let errNum = 0
        setErrorNum(errNum)
        for (let file of fileList) {
            try {
                const res = await onUpload(file, resourceType, commoditySceneMode)
                if (!res) continue
                succNum++
                setSuccNum(succNum)
            } catch (err) {
                errNum++
                setErrorNum(succNum)
                console.error(err)
                message.warning(err?.message)
                continue
            }
            onUpdate()
        }
        // 上传完成
        if (errNum == totalNum) { // 全部失败
            if (totalNum != 1) message.warning('上传失败，请重新上传符合要求的资源！')
        } else if (errNum != 0) { // 部分失败
            message.info(`${errNum}张上传失败，请重新上传符合要求的资源`)
        } else if (succNum == totalNum) { // 全部成功
            message.success('上传成功')
        } else {
            // 全部取消，不做任何处理
        }
        setLoading(false)
    }, 100), [resourceType, commoditySceneMode, onUpdate])
    // 上传文件
    const beforeUpload = async (file, fileList) => {
        if (loading) return
        uploadDebounce(file, fileList)
        return false
    }
    // 上传文件
    const handleDrop = async (e) => {
        if (loading) return
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList)
            return false
        }
    }

    const title = useMemo(() => {
        console.log('resourceType', resourceType)
        const triggerText = resourceType == RESOURCE_TYPE.TRYON_MODEL ? "上传参考图" :
                resourceType == RESOURCE_TYPE.POSE_TRYON ? "上传参考图" :
                    resourceType == RESOURCE_TYPE.GLASSES_TRYON ? "上传参考图" :
                        resourceType == RESOURCE_TYPE.NECKLACE_TRYON ? "上传参考图" :
                        resourceType == RESOURCE_TYPE.SIM_TRYON ? "上传参考图" :
                        resourceType == RESOURCE_TYPE.MODEL ? "上传模特" :
                            resourceType == RESOURCE_TYPE.MODEL_SCENE ? "上传背景" :
                                resourceType == RESOURCE_TYPE.TRYON_SCENE ? "上传背景" :
                                    resourceType == RESOURCE_TYPE.TRYON_SHOES ? "上传参考图" :
                                        resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "上传动作" :
                                            resourceType == RESOURCE_TYPE.COMMODITY_SCENE ? "上传背景" :
                                                resourceType == RESOURCE_TYPE.COMMODITY_COLOR || resourceType == RESOURCE_TYPE.CLOTH_RECOLOR ? "上传颜色" :
                                                    resourceType == RESOURCE_TYPE.GRASS_PLANT ? "上传种草图" :
                                                        ""
        return triggerText
    }, [resourceType])

    return (
        <div className={styles.SelectionItem}>
            {
                (resourceType == RESOURCE_TYPE.MODEL || useModalTrigger) ?
                    <div className={`${styles.SelectionItemUploadTrigger} ${styles.ModalTrigger}`} onClick={() => {
                        if (useModalTrigger) onTriggerClick?.()
                        else onUpload(null, resourceType)
                    }} >
                        <div className={styles.SelectionItemUploadContent}>
                            <PlusOutlined />
                            <span>{title}</span>
                            {showUploadRequire &&
                                <Popover
                                    trigger="hover"
                                    placement="bottomLeft"
                                    arrow={false}
                                    content={<UploadRequirements resourceType={resourceType} commoditySceneMode={commoditySceneMode} />}
                                    onClick={e => e.stopPropagation()}
                                >
                                    <span className={styles.RequireTrigger}>{resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "视频要求" : "图片要求"}</span>
                                </Popover>}
                        </div>
                    </div> :
                    <Upload.Dragger
                        className={styles.SelectionItemUploadTrigger}
                        multiple={uploadMultiple}
                        maxCount={30}
                        accept={uploadAccept}
                        showUploadList={false}
                        beforeUpload={beforeUpload}
                        onDrop={handleDrop}
                        disabled={loading}
                    >
                        <div className={styles.SelectionItemUploadContent}>
                            {loading ? <LoadingOutlined /> : <PlusOutlined />}
                            <span>{loading ? `已上传 ${succNum}/${totalNum}` : title}</span>
                            {showUploadRequire &&
                                <Popover
                                    trigger="hover"
                                    placement="bottomLeft"
                                    arrow={false}
                                    content={<UploadRequirements resourceType={resourceType} commoditySceneMode={commoditySceneMode} />}
                                    onClick={e => e.stopPropagation()}
                                >
                                    <span className={styles.RequireTrigger}>{resourceType == RESOURCE_TYPE.VIDEO_MODEL ? "视频要求" : "图片要求"}</span>
                                </Popover>}
                        </div>
                    </Upload.Dragger>
            }
        </div>
    )
}

SelectionItem.Uploader = SelectionItemUploader

export default SelectionItem
